import * as React from 'react';
import { SVGProps } from 'react';

const IconShapeSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 3h3v2h12V3h3v3h-2v12h2v3h-3v-2H6v2H3v-3h2V6H3V3zm14 4H7v10h10V7z"
    />
  </svg>
);
export default IconShapeSizeM;
